import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box, Collapse, IconButton, Link, Typography } from "@mui/material";
import { observer as hooksObserver } from "mobx-react-lite";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { ROUTE_PUBLIC_INVESTIGATION_RESULT } from "routes/RouteList";
import { fetchPublicInvestigationCallbackStatus } from "services/api";

const searchTypeLabel = (searchType) => (searchType === "owners" ? "eigenaars" : "bewoners");

const noticeBoxSx = {
  mt: 2,
  mb: 1,
  px: 1.5,
  py: 1,
  borderRadius: 1,
  border: "1px solid",
  borderColor: "success.light",
  bgcolor: "rgba(46, 125, 50, 0.04)",
};

const CallbackStatusNotice = hooksObserver(({ investigationId }) => {
  const [callbackStatus, setCallbackStatus] = useState(null);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const loadCallbackStatus = async () => {
      if (!investigationId) {
        setCallbackStatus(null);
        return;
      }

      const data = await fetchPublicInvestigationCallbackStatus(investigationId);
      setCallbackStatus(data || null);
    };

    loadCallbackStatus();
  }, [investigationId]);

  if (!callbackStatus) {
    return null;
  }

  const sentAt = callbackStatus.responseTime ? new Date(callbackStatus.responseTime).toLocaleString("nl-BE") : null;
  const merged = callbackStatus.mergedSpatialResearch;
  const hasDetails = !!sentAt || !!merged;

  return (
    <Box sx={noticeBoxSx}>
      <Box sx={{ display: "flex", alignItems: "flex-start", gap: 0.5 }}>
        <CheckCircleOutlineIcon color="success" sx={{ fontSize: 18, mt: 0.25, flexShrink: 0 }} />
        <Typography variant="body2" sx={{ flex: 1, color: "success.dark", lineHeight: 1.4 }}>
          Aanpalers doorgestuurd naar Omgeving.NET
        </Typography>
        {hasDetails && (
          <IconButton
            size="small"
            aria-label={expanded ? "Details verbergen" : "Details tonen"}
            onClick={() => setExpanded((value) => !value)}
            sx={{ mt: -0.5, mr: -0.5 }}
          >
            {expanded ? <ExpandLessIcon fontSize="small" /> : <ExpandMoreIcon fontSize="small" />}
          </IconButton>
        )}
      </Box>

      {hasDetails && (
        <Collapse in={expanded} timeout="auto" unmountOnExit>
          <Box sx={{ pl: 3, pt: 0.5 }}>
            {sentAt && (
              <Typography variant="caption" color="text.secondary" display="block">
                {sentAt}
              </Typography>
            )}
            {merged && (
              <Typography variant="body2" sx={{ mt: sentAt ? 0.5 : 0 }}>
                Bij het doorsturen werden de gegevens samengevoegd met het {searchTypeLabel(merged.searchType)} onderzoek{" "}
                <Link
                  component="button"
                  variant="body2"
                  underline="hover"
                  onClick={() => {
                    window.location.assign(`${ROUTE_PUBLIC_INVESTIGATION_RESULT}/${merged.id}`);
                  }}
                >
                  {merged.titel}
                </Link>
                .
              </Typography>
            )}
          </Box>
        </Collapse>
      )}
    </Box>
  );
});

CallbackStatusNotice.propTypes = {
  investigationId: PropTypes.string,
};

export default CallbackStatusNotice;
